import { render, staticRenderFns } from "./GridForQueryData.vue?vue&type=template&id=7f28801a&"
import script from "./GridForQueryData.vue?vue&type=script&lang=js&"
export * from "./GridForQueryData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports